/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PatchedProPreferencesRequest,
  ProPreferences,
  ProPreferencesAvailabilityListParams,
  ProPreferencesAvailabilityWeekListParams,
  ProPreferencesOptionsResponse,
  ProPreferencesRequest,
  ProPreferencesRetrieveResponse,
  ProShiftAvailabilityEntryRequest,
  ProShiftAvailabilitySlice
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProPreferencesCreateUrl = () => {




  return `/api/pro-preferences/`
}

/**
 * Pro preferences can be created, updated, partial updated and retrieved using this view. Use /me/ to
 * reference current user's preferences.
 */
export const proPreferencesCreate = async (proPreferencesRequest?: ProPreferencesRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProPreferences> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProPreferences>(getProPreferencesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proPreferencesRequest)
  }
);}





export const getProPreferencesCreateMutationKey = () => ['proPreferencesCreate'] as const;

export const getProPreferencesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesCreate>>, TError,ProPreferencesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesCreate>>, TError,ProPreferencesCreateMutationVariables, TContext> => {

const mutationKey = getProPreferencesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesCreate>>, ProPreferencesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proPreferencesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesCreate>>>
    export type ProPreferencesCreateMutationBody = ProPreferencesRequest | undefined
    export type ProPreferencesCreateMutationError = void
    export type ProPreferencesCreateMutationVariables = {data?: ProPreferencesRequest}

    export const useProPreferencesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesCreate>>, TError,ProPreferencesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesCreate>>,
        TError,
        ProPreferencesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesCreateMutationOptions(options), queryClient);
    }
    export const getProPreferencesRetrieveUrl = (id: number,) => {




  return `/api/pro-preferences/${id}/`
}

/**
 * Pro preferences can be created, updated, partial updated and retrieved using this view. Use /me/ to
 * reference current user's preferences.
 */
export const proPreferencesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ProPreferencesRetrieveResponse> => {

  return customFetch<ProPreferencesRetrieveResponse>(getProPreferencesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProPreferencesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/pro-preferences/${id}/`
    ] as const;
    }


export const getProPreferencesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProPreferencesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proPreferencesRetrieve>>> = ({ signal }) => proPreferencesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProPreferencesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proPreferencesRetrieve>>>
export type ProPreferencesRetrieveQueryError = void


export function useProPreferencesRetrieve<TData = Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesRetrieve<TData = Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesRetrieve<TData = Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProPreferencesRetrieve<TData = Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProPreferencesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProPreferencesUpdateUrl = (id: number,) => {




  return `/api/pro-preferences/${id}/`
}

/**
 * Pro preferences can be created, updated, partial updated and retrieved using this view. Use /me/ to
 * reference current user's preferences.
 */
export const proPreferencesUpdate = async (id: number,
    proPreferencesRequest?: ProPreferencesRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProPreferences> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProPreferences>(getProPreferencesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proPreferencesRequest)
  }
);}





export const getProPreferencesUpdateMutationKey = () => ['proPreferencesUpdate'] as const;

export const getProPreferencesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesUpdate>>, TError,ProPreferencesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesUpdate>>, TError,ProPreferencesUpdateMutationVariables, TContext> => {

const mutationKey = getProPreferencesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesUpdate>>, ProPreferencesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proPreferencesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesUpdate>>>
    export type ProPreferencesUpdateMutationBody = ProPreferencesRequest | undefined
    export type ProPreferencesUpdateMutationError = void
    export type ProPreferencesUpdateMutationVariables = {id: number;data?: ProPreferencesRequest}

    export const useProPreferencesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesUpdate>>, TError,ProPreferencesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesUpdate>>,
        TError,
        ProPreferencesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesUpdateMutationOptions(options), queryClient);
    }
    export const getProPreferencesPartialUpdateUrl = (id: number,) => {




  return `/api/pro-preferences/${id}/`
}

/**
 * Pro preferences can be created, updated, partial updated and retrieved using this view. Use /me/ to
 * reference current user's preferences.
 */
export const proPreferencesPartialUpdate = async (id: number,
    patchedProPreferencesRequest?: PatchedProPreferencesRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProPreferences> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProPreferences>(getProPreferencesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProPreferencesRequest)
  }
);}





export const getProPreferencesPartialUpdateMutationKey = () => ['proPreferencesPartialUpdate'] as const;

export const getProPreferencesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesPartialUpdate>>, TError,ProPreferencesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesPartialUpdate>>, TError,ProPreferencesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getProPreferencesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesPartialUpdate>>, ProPreferencesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proPreferencesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesPartialUpdate>>>
    export type ProPreferencesPartialUpdateMutationBody = PatchedProPreferencesRequest | undefined
    export type ProPreferencesPartialUpdateMutationError = void
    export type ProPreferencesPartialUpdateMutationVariables = {id: number;data?: PatchedProPreferencesRequest}

    export const useProPreferencesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesPartialUpdate>>, TError,ProPreferencesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesPartialUpdate>>,
        TError,
        ProPreferencesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getProPreferencesAvailabilityListUrl = (params?: ProPreferencesAvailabilityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro-preferences/availability/?${stringifiedParams}` : `/api/pro-preferences/availability/`
}

/**
 * ``GET /availability/`` -- same per-day slices as ``/week/`` (admins may pass ``?pro=``).
 */
export const proPreferencesAvailabilityList = async (params?: ProPreferencesAvailabilityListParams, options?: Parameters<typeof customFetch>[1]): Promise<ProShiftAvailabilitySlice[]> => {

  return customFetch<ProShiftAvailabilitySlice[]>(getProPreferencesAvailabilityListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProPreferencesAvailabilityListQueryKey = (params?: ProPreferencesAvailabilityListParams,) => {
    return [
    `/api/pro-preferences/availability/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProPreferencesAvailabilityListQueryOptions = <TData = Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError = void>(params?: ProPreferencesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProPreferencesAvailabilityListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>> = ({ signal }) => proPreferencesAvailabilityList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProPreferencesAvailabilityListQueryResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>>
export type ProPreferencesAvailabilityListQueryError = void


export function useProPreferencesAvailabilityList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError = void>(
 params: undefined |  ProPreferencesAvailabilityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesAvailabilityList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError = void>(
 params?: ProPreferencesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesAvailabilityList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError = void>(
 params?: ProPreferencesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProPreferencesAvailabilityList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError = void>(
 params?: ProPreferencesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProPreferencesAvailabilityListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProPreferencesAvailabilityCreateUrl = () => {




  return `/api/pro-preferences/availability/`
}

/**
 * ``POST /availability/`` -- add one entry, merged into the pro's existing schedule.
 */
export const proPreferencesAvailabilityCreate = async (proShiftAvailabilityEntryRequest?: ProShiftAvailabilityEntryRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProShiftAvailabilitySlice[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProShiftAvailabilitySlice[]>(getProPreferencesAvailabilityCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proShiftAvailabilityEntryRequest)
  }
);}





export const getProPreferencesAvailabilityCreateMutationKey = () => ['proPreferencesAvailabilityCreate'] as const;

export const getProPreferencesAvailabilityCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>, TError,ProPreferencesAvailabilityCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>, TError,ProPreferencesAvailabilityCreateMutationVariables, TContext> => {

const mutationKey = getProPreferencesAvailabilityCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>, ProPreferencesAvailabilityCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proPreferencesAvailabilityCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesAvailabilityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>>
    export type ProPreferencesAvailabilityCreateMutationBody = ProShiftAvailabilityEntryRequest | undefined
    export type ProPreferencesAvailabilityCreateMutationError = void
    export type ProPreferencesAvailabilityCreateMutationVariables = {data?: ProShiftAvailabilityEntryRequest}

    export const useProPreferencesAvailabilityCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>, TError,ProPreferencesAvailabilityCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesAvailabilityCreate>>,
        TError,
        ProPreferencesAvailabilityCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesAvailabilityCreateMutationOptions(options), queryClient);
    }
    export const getProPreferencesAvailabilityBulkDeleteDestroyUrl = () => {




  return `/api/pro-preferences/availability/bulk-delete/`
}

/**
 * Clear the authenticated pro's entire schedule.
 */
export const proPreferencesAvailabilityBulkDeleteDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getProPreferencesAvailabilityBulkDeleteDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProPreferencesAvailabilityBulkDeleteDestroyMutationKey = () => ['proPreferencesAvailabilityBulkDeleteDestroy'] as const;

export const getProPreferencesAvailabilityBulkDeleteDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>, TError,void, TContext> => {

const mutationKey = getProPreferencesAvailabilityBulkDeleteDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>, void> = () => {


          return  proPreferencesAvailabilityBulkDeleteDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesAvailabilityBulkDeleteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>>

    export type ProPreferencesAvailabilityBulkDeleteDestroyMutationError = void


    export const useProPreferencesAvailabilityBulkDeleteDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesAvailabilityBulkDeleteDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getProPreferencesAvailabilityBulkDeleteDestroyMutationOptions(options), queryClient);
    }
    export const getProPreferencesAvailabilityWeekListUrl = (params?: ProPreferencesAvailabilityWeekListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro-preferences/availability/week/?${stringifiedParams}` : `/api/pro-preferences/availability/week/`
}

/**
 * Read or replace the pro's weekly availability.
 *
 * * ``GET`` -- every entry for the pro (or ``?pro=<id>`` for a gigpro admin), unpaginated.
 * * ``PUT`` -- full replace: the posted list becomes the entire week (idempotent).
 * * ``PATCH`` -- partial: replaces only the days present in the payload, leaving other days
 *   untouched. (Distinct from ``PUT``, which clears omitted days.)
 *
 * Entries are per-day ``{day_of_week_digit, start_time, end_time}`` (``end_time`` may be
 * ``"24:00"``); the service merges touching/overlapping intervals before storing.
 */
export const proPreferencesAvailabilityWeekList = async (params?: ProPreferencesAvailabilityWeekListParams, options?: Parameters<typeof customFetch>[1]): Promise<ProShiftAvailabilitySlice[]> => {

  return customFetch<ProShiftAvailabilitySlice[]>(getProPreferencesAvailabilityWeekListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProPreferencesAvailabilityWeekListQueryKey = (params?: ProPreferencesAvailabilityWeekListParams,) => {
    return [
    `/api/pro-preferences/availability/week/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProPreferencesAvailabilityWeekListQueryOptions = <TData = Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError = void>(params?: ProPreferencesAvailabilityWeekListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProPreferencesAvailabilityWeekListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>> = ({ signal }) => proPreferencesAvailabilityWeekList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProPreferencesAvailabilityWeekListQueryResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>>
export type ProPreferencesAvailabilityWeekListQueryError = void


export function useProPreferencesAvailabilityWeekList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError = void>(
 params: undefined |  ProPreferencesAvailabilityWeekListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesAvailabilityWeekList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError = void>(
 params?: ProPreferencesAvailabilityWeekListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesAvailabilityWeekList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError = void>(
 params?: ProPreferencesAvailabilityWeekListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProPreferencesAvailabilityWeekList<TData = Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError = void>(
 params?: ProPreferencesAvailabilityWeekListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProPreferencesAvailabilityWeekListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProPreferencesAvailabilityWeekUpdateUrl = () => {




  return `/api/pro-preferences/availability/week/`
}

/**
 * Read or replace the pro's weekly availability.
 *
 * * ``GET`` -- every entry for the pro (or ``?pro=<id>`` for a gigpro admin), unpaginated.
 * * ``PUT`` -- full replace: the posted list becomes the entire week (idempotent).
 * * ``PATCH`` -- partial: replaces only the days present in the payload, leaving other days
 *   untouched. (Distinct from ``PUT``, which clears omitted days.)
 *
 * Entries are per-day ``{day_of_week_digit, start_time, end_time}`` (``end_time`` may be
 * ``"24:00"``); the service merges touching/overlapping intervals before storing.
 */
export const proPreferencesAvailabilityWeekUpdate = async (proShiftAvailabilityEntryRequest: ProShiftAvailabilityEntryRequest[], options?: Parameters<typeof customFetch>[1]): Promise<ProShiftAvailabilitySlice[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProShiftAvailabilitySlice[]>(getProPreferencesAvailabilityWeekUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proShiftAvailabilityEntryRequest)
  }
);}





export const getProPreferencesAvailabilityWeekUpdateMutationKey = () => ['proPreferencesAvailabilityWeekUpdate'] as const;

export const getProPreferencesAvailabilityWeekUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>, TError,ProPreferencesAvailabilityWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>, TError,ProPreferencesAvailabilityWeekUpdateMutationVariables, TContext> => {

const mutationKey = getProPreferencesAvailabilityWeekUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>, ProPreferencesAvailabilityWeekUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proPreferencesAvailabilityWeekUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesAvailabilityWeekUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>>
    export type ProPreferencesAvailabilityWeekUpdateMutationBody = ProShiftAvailabilityEntryRequest[]
    export type ProPreferencesAvailabilityWeekUpdateMutationError = void
    export type ProPreferencesAvailabilityWeekUpdateMutationVariables = {data: ProShiftAvailabilityEntryRequest[]}

    export const useProPreferencesAvailabilityWeekUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>, TError,ProPreferencesAvailabilityWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesAvailabilityWeekUpdate>>,
        TError,
        ProPreferencesAvailabilityWeekUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesAvailabilityWeekUpdateMutationOptions(options), queryClient);
    }
    export const getProPreferencesAvailabilityWeekPartialUpdateUrl = () => {




  return `/api/pro-preferences/availability/week/`
}

/**
 * Read or replace the pro's weekly availability.
 *
 * * ``GET`` -- every entry for the pro (or ``?pro=<id>`` for a gigpro admin), unpaginated.
 * * ``PUT`` -- full replace: the posted list becomes the entire week (idempotent).
 * * ``PATCH`` -- partial: replaces only the days present in the payload, leaving other days
 *   untouched. (Distinct from ``PUT``, which clears omitted days.)
 *
 * Entries are per-day ``{day_of_week_digit, start_time, end_time}`` (``end_time`` may be
 * ``"24:00"``); the service merges touching/overlapping intervals before storing.
 */
export const proPreferencesAvailabilityWeekPartialUpdate = async (proShiftAvailabilityEntryRequest: ProShiftAvailabilityEntryRequest[], options?: Parameters<typeof customFetch>[1]): Promise<ProShiftAvailabilitySlice[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProShiftAvailabilitySlice[]>(getProPreferencesAvailabilityWeekPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proShiftAvailabilityEntryRequest)
  }
);}





export const getProPreferencesAvailabilityWeekPartialUpdateMutationKey = () => ['proPreferencesAvailabilityWeekPartialUpdate'] as const;

export const getProPreferencesAvailabilityWeekPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>, TError,ProPreferencesAvailabilityWeekPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>, TError,ProPreferencesAvailabilityWeekPartialUpdateMutationVariables, TContext> => {

const mutationKey = getProPreferencesAvailabilityWeekPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>, ProPreferencesAvailabilityWeekPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proPreferencesAvailabilityWeekPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProPreferencesAvailabilityWeekPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>>
    export type ProPreferencesAvailabilityWeekPartialUpdateMutationBody = ProShiftAvailabilityEntryRequest[]
    export type ProPreferencesAvailabilityWeekPartialUpdateMutationError = void
    export type ProPreferencesAvailabilityWeekPartialUpdateMutationVariables = {data: ProShiftAvailabilityEntryRequest[]}

    export const useProPreferencesAvailabilityWeekPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>, TError,ProPreferencesAvailabilityWeekPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proPreferencesAvailabilityWeekPartialUpdate>>,
        TError,
        ProPreferencesAvailabilityWeekPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProPreferencesAvailabilityWeekPartialUpdateMutationOptions(options), queryClient);
    }
    export const getProPreferencesOptionsRetrieveUrl = () => {




  return `/api/pro-preferences/options/`
}

/**
 * options/ endpoint will return all available options for pro preferences.
 */
export const proPreferencesOptionsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProPreferencesOptionsResponse> => {

  return customFetch<ProPreferencesOptionsResponse>(getProPreferencesOptionsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProPreferencesOptionsRetrieveQueryKey = () => {
    return [
    `/api/pro-preferences/options/`
    ] as const;
    }


export const getProPreferencesOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProPreferencesOptionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>> = ({ signal }) => proPreferencesOptionsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProPreferencesOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>>
export type ProPreferencesOptionsRetrieveQueryError = void


export function useProPreferencesOptionsRetrieve<TData = Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesOptionsRetrieve<TData = Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProPreferencesOptionsRetrieve<TData = Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProPreferencesOptionsRetrieve<TData = Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proPreferencesOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProPreferencesOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






